import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';
import { SKIP_LOADER } from '../tokens/skip-loader.token'

// Track the number of active HTTP requests
let activeRequests = 0;
export const LoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.context.get(SKIP_LOADER)) {
    return next(req);
  }

  if (activeRequests === 0) {
    loaderService.show(); // Show loader only when the first request starts
  }

  activeRequests++; // Increment active requests count

  return next(req).pipe(
    finalize(() => {
      activeRequests--; // Decrement when request completes

      if (activeRequests === 0) {
        loaderService.hide(); // Hide loader only when all requests are done
      }
    })
  );
};
